import Axios from "axios";
const util={
	case_confirm_status: {
		'waiting_confirm': {
			code: 1,
			label: '待审核'
		},
		'fail': {
			code: 2,
			label: '审核失败'
		},
		'success': {
			code: 3,
			label: '审核成功'
		},
		'no_confirm': {
			code: 4,
			label: '不需要审核'
		},
	},
	case_confirm_status_label: {
		1: {
			label: '待审核'
		},
		2: {
			label: '审核失败'
		},
		3: {
			label: '审核成功'
		},
		4: {
			label: '不需要审核'
		},
	},
	case_course_status: {
		'filtering': {
			code: 10,
			label: '待筛选'
		},
		'on': {
			code: 20,
			label: '筛查通过'
		},
	},
	case_course_status_label: {
		10: {
			label: '待筛选'
		},
		20: {
			label: '筛查通过'
		},
	},
	//遍历对象，值为空就删除这个键
	delObjItem(obj) {
		let newObj = obj
		for (var i in newObj) {
			if (newObj[i] == '' && newObj[i] !== 0 && newObj[i] !== '0') {
				delete newObj[i]
			}
		}
		return newObj
	},
	config:{
		competition_status:'competition_status',
		solicitation_requirements:'solicitation_requirements',
		operation_notice:'operation_notice',
		competition_notification:'competition_notification',
		score_distributed: 'score_distributed'
	},
	//判断密码是否符合规范
	reg:{
		regPwd:/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{8,32}$/,
		regPwdMsg:'您的密码复杂度太低（密码中必须包含大小写字母+数字，长度8-32位）!',
		resetPwdText:'Abc123456'
	},
	//设置文件上传icon
	setFileIcon(res) {
		const type = res.split('.').pop()
		let src = ''
		switch (type) {
			case 'doc':
			case 'docx':
				src = require('@/assets/file-icon/word.png');
				break;
			case 'xlsx':
			case 'xls':
				src = require('@/assets/file-icon/excel.png');
				break;
			case 'pdf':
				src = require('@/assets/file-icon/pdf.png');
				break
			case 'ppt':
			case 'pptx':
				src = require('@/assets/file-icon/ppt.png');
				break
			case 'jpg':
				src = require('@/assets/file-icon/jpg.png');
				break
			case 'png':
				src = require('@/assets/file-icon/png.png');
				break
			case 'mp4':
				src = require('@/assets/file-icon/mp4.png');
				break
			case 'mp3':
				src = require('@/assets/file-icon/AUDIO.svg');
				break
		}
		return src
	},
	//读取oss图片大小
	imgSize: {
		imgG1: '!g1',
		imgG2: '!g2',
		imgQ30: '!q30',
		imgQ70: '!q70',
		imgQ15: '!q15',
		imgQ40: '!q40',
		imgQ100: '!q100',
		imgQ90: '!q90',
	},
	
	// setStage:{
	// 	1:'小学组',
	// 	2:'初中组',
	// 	3:'高中组',
	// },
	setStage(arr) {
		// 适配grade为null的情况
		// 先按stage分组
		const stageMap = {};
		const nullGradeStages = new Set();
		if (!arr || arr.length === 0) return '';

		arr.forEach(item => {
			if (!stageMap[item.stage]) stageMap[item.stage] = [];
			let g = item.grade;
			if (g === null || g === undefined) {
				nullGradeStages.add(item.stage);
			} else {
				if (typeof g === 'string' && /^\d+$/.test(g)) g = parseInt(g);
				stageMap[item.stage].push(g);
			}
		});

		const stageNames = {
			1: '小学',
			2: '初中',
			3: '高中',
			4: '幼儿园'
		};
		const kindergartenGradeMap = {
			1: '小班',
			2: '中班',
			3: '大班'
		};

		const result = [];

		// 处理grade为null且该stage没有grade有值的情况
		nullGradeStages.forEach(stageKey => {
			if (!stageMap[stageKey] || stageMap[stageKey].length === 0) {
				// 该stage下只有grade为null的数据
				if (stageNames[stageKey]) {
					result.push(stageNames[stageKey]);
				}
			}
		});

		Object.keys(stageMap).sort((a, b) => a - b).forEach(stageKey => {
			const grades = stageMap[stageKey].filter(g => g != null).map(Number).sort((a, b) => a - b);
			const stage = Number(stageKey);

			if (grades.length === 0) {
				// 已在上面处理
				return;
			}

			if (stage === 4) {
				// 幼儿园
				if (grades.length === 1) {
					result.push('幼儿园' + kindergartenGradeMap[grades[0]]);
				} else if (grades.length > 1) {
					// 连续的合并为区间
					let ranges = [];
					let start = grades[0], end = grades[0];
					for (let i = 1; i < grades.length; i++) {
						if (grades[i] === end + 1) {
							end = grades[i];
						} else {
							ranges.push([start, end]);
							start = grades[i];
							end = grades[i];
						}
					}
					ranges.push([start, end]);
					const rangeStr = ranges.map(([s, e]) => {
						if (s === e) return kindergartenGradeMap[s];
						return kindergartenGradeMap[s] + '-' + kindergartenGradeMap[e];
					}).join('、');
					result.push('幼儿园' + rangeStr);
				}
			} else if (stage === 1) {
				// 小学
				if (grades.length === 1) {
					result.push('小学' + grades[0] + '年级');
				} else if (grades.length > 1) {
					let ranges = [];
					let start = grades[0], end = grades[0];
					for (let i = 1; i < grades.length; i++) {
						if (grades[i] === end + 1) {
							end = grades[i];
						} else {
							ranges.push([start, end]);
							start = grades[i];
							end = grades[i];
						}
					}
					ranges.push([start, end]);
					const rangeStr = ranges.map(([s, e]) => {
						if (s === e) return s + '年级';
						return s + '-' + e + '年级';
					}).join('、');
					result.push('小学' + rangeStr);
				}
			} else if (stage === 2) {
				// 初中
				if (grades.length === 1) {
					result.push('初中' + grades[0] + '年级');
				} else if (grades.length > 1) {
					let ranges = [];
					let start = grades[0], end = grades[0];
					for (let i = 1; i < grades.length; i++) {
						if (grades[i] === end + 1) {
							end = grades[i];
						} else {
							ranges.push([start, end]);
							start = grades[i];
							end = grades[i];
						}
					}
					ranges.push([start, end]);
					const rangeStr = ranges.map(([s, e]) => {
						if (s === e) return s + '年级';
						return s + '-' + e + '年级';
					}).join('、');
					result.push('初中' + rangeStr);
				}
			} else if (stage === 3) {
				// 高中
				if (grades.length === 1) {
					result.push('高中' + grades[0] + '年级');
				} else if (grades.length > 1) {
					let ranges = [];
					let start = grades[0], end = grades[0];
					for (let i = 1; i < grades.length; i++) {
						if (grades[i] === end + 1) {
							end = grades[i];
						} else {
							ranges.push([start, end]);
							start = grades[i];
							end = grades[i];
						}
					}
					ranges.push([start, end]);
					const rangeStr = ranges.map(([s, e]) => {
						if (s === e) return s + '年级';
						return s + '-' + e + '年级';
					}).join('、');
					result.push('高中' + rangeStr);
				}
			}
		});

		return result.join('，');
	},
	
	// 获取文件大小
	getFileSize(fileSize) {
		if (fileSize < 1024) {
			return fileSize + 'B';
		} else if (fileSize < (1024 * 1024)) {
			var temp = fileSize / 1024;
			temp = temp.toFixed(2);
			return temp + 'KB';
		} else if (fileSize < (1024 * 1024 * 1024)) {
			var temp = fileSize / (1024 * 1024);
			temp = temp.toFixed(2);
			return temp + 'MB';
		} else {
			var temp = fileSize / (1024 * 1024 * 1024);
			temp = temp.toFixed(2);
			return temp + 'GB';
		}
	},
	// 传入字段判断存不存在
	getIsHasField(fieldName) {
		let arr = JSON.parse(sessionStorage.getItem('fieldOptions'));
		let found = arr.find(item => item.name === fieldName);
		if (found) {
			return found.status;
		}
		return false;
	},
	// 获取对应key的值
	getKeyFrontValue(itemKey) {
		let arr = JSON.parse(sessionStorage.getItem('fieldOptions'))
		let str = ''
		arr.forEach((item => {
			if(item.name == itemKey) {
				str = item.value
			}
		}))
		return str
	},

	// 时间戳+随机数
	getDate() {
		let date = Date.parse(new Date())
		let random = Math.floor(Math.random() * 90 + 10)
		let str = date + random
		return str
	},
	getFileName() {
		let str = '/course_competition/uploads/'  + this.getDate() + '_'
		return str
	},

	// 设置oss配置
	setOssConfig(osskey) {
		let key = "all" + (process.env.NODE_ENV != 'docker' ? '-test' : '')
		if (osskey) {
			key = osskey
		}
		Axios.request({
			url: '/oss_config/token',
			baseURL: process.env.VUE_APP_URL,
			params: {
				key: key,
			},
			headers: {},
			commonApi: true,
			method: 'get',
		}).then(res => {
			if (res.code == 200) sessionStorage.setItem('OssConfig', JSON.stringify(res.data))
		})
	},
}
Vue.prototype.util = util;